// Avisa al servidor que entro una visita; el servidor filtra bots y envia el mail.
const SESSION_KEY = 'np_visit_notified';

export const notifyLandingVisit = () => {
  try {
    if (sessionStorage.getItem(SESSION_KEY)) return;
    sessionStorage.setItem(SESSION_KEY, '1');
  } catch {
    // sessionStorage no disponible: se notifica igual
  }
  fetch('/visit-notify', { method: 'POST', keepalive: true }).catch(() => {});
};
